import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import CountUp from "react-countup";
import { useSelector, useDispatch } from "react-redux";
import getLoaderActions from "../../actions/LoaderActions";
import getMode from "../../actions/modeActions";
import { allCurrency, getDateFormat, roundOffTwoDecimal } from "../../util";
import DatePicker from "react-datepicker";
import "./ROI.css";
import "react-datepicker/dist/react-datepicker.css";
const ROI = () => {
  const [coinData, setcoinData] = useState([]);
  const [viewROI, setviewROI] = useState(false);
  const [currency, setcurrency] = useState("inr");
  const loader = useSelector((state) => state.Loader.state);
  const [startDate, setstartDate] = useState(null);
  const [startDatePrice, setstartDatePrice] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [endDatePrice, setendDatePrice] = useState(null);
  const [ROI, setROI] = useState(null);
  const [coin, setcoin] = useState(null);
  const [imgUrl, setimgUrl] = useState("");

  const startDateRef = useRef();
  const endDateRef = useRef();
  const coinRef = useRef();

  const mode = useSelector((state) => state.mode.payload);

  const dispatch = useDispatch();

  useEffect(() => {
    axios
      .get(
        "https://api.coingecko.com/api/v3/coins/markets?vs_currency=inr&order=market_cap_desc&per_page=100&page=1&sparkline=false"
      )
      .then((response) => {
        setcoinData(response.data);

        dispatch(getLoaderActions("true"));

        dispatch(getMode(localStorage.getItem("mode")));
      });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const postDataCurrency = (e) => {
    setcurrency(e.target.value);
    if (
      startDateRef.current.props.selected &&
      endDateRef.current.props.selected
    ) {
      axios
        .get(
          `https://api.coingecko.com/api/v3/coins/${coin}/history?date=${getDateFormat(
            startDateRef.current.props.selected
          )}`
        )
        .then((response) => {
          setstartDatePrice(
            response.data.market_data.current_price[e.target.value]
          );
          var startDatePrices =
            response.data.market_data.current_price[e.target.value];
          setimgUrl(response.data.image.small);
          axios
            .get(
              `https://api.coingecko.com/api/v3/coins/${coin}/history?date=${getDateFormat(
                endDateRef.current.props.selected
              )}`
            )
            .then((response) => {
              setendDatePrice(
                response.data.market_data.current_price[e.target.value]
              );
              var temp =
                response.data.market_data.current_price[e.target.value] -
                startDatePrices;
              setROI((temp / startDatePrices) * 100);
              setimgUrl(response.data.image.small);
            });
        });
    }
  };
  const startDateValues = (e) => {
    setstartDate(e);
    axios
      .get(
        `https://api.coingecko.com/api/v3/coins/${coin}/history?date=${getDateFormat(
          e
        )}`
      )
      .then((response) => {
        setstartDatePrice(response.data.market_data.current_price[currency]);
        setimgUrl(response.data.image.small);
      })
      .catch((error) => {});
    if (
      startDateRef.current.props.selected &&
      endDateRef.current.props.selected
    ) {
      axios
        .get(
          `https://api.coingecko.com/api/v3/coins/${coin}/history?date=${getDateFormat(
            e
          )}`
        )
        .then((response) => {
          setstartDatePrice(response.data.market_data.current_price[currency]);
          var start_date = response.data.market_data.current_price[currency];
          setimgUrl(response.data.image.small);
          axios
            .get(
              `https://api.coingecko.com/api/v3/coins/${coin}/history?date=${getDateFormat(
                endDateRef.current.props.selected
              )}`
            )
            .then((response) => {
              setendDatePrice(
                response.data.market_data.current_price[currency]
              );
              var end_date = response.data.market_data.current_price[currency];
              var temp = end_date - start_date;
              setROI((temp / start_date) * 100);
              setimgUrl(response.data.image.small);
            });
        });
    }
  };
  const endDateValues = (e) => {
    setendDate(e);

    axios
      .get(
        `https://api.coingecko.com/api/v3/coins/${coin}/history?date=${getDateFormat(
          e
        )}`
      )
      .then((response) => {
        setendDatePrice(response.data.market_data.current_price[currency]);
      })
      .catch((error) => {});
    if (
      startDateRef.current.props.selected &&
      endDateRef.current.props.selected
    ) {
      axios
        .get(
          `https://api.coingecko.com/api/v3/coins/${coin}/history?date=${getDateFormat(
            startDateRef.current.props.selected
          )}`
        )
        .then((response) => {
          setstartDatePrice(response.data.market_data.current_price[currency]);
          var start_date = response.data.market_data.current_price[currency];
          setimgUrl(response.data.image.small);

          axios
            .get(
              `https://api.coingecko.com/api/v3/coins/${coin}/history?date=${getDateFormat(
                e
              )}`
            )
            .then((response) => {
              setendDatePrice(
                response.data.market_data.current_price[currency]
              );
              var end_date = response.data.market_data.current_price[currency];
              var temp = end_date - start_date;
              setROI((temp / start_date) * 100);
              setimgUrl(response.data.image.small);
            });
        });
    }
  };
  const calculateROI = (e) => {
    e.preventDefault();

    var diff = endDatePrice - startDatePrice;

    setROI((diff / startDatePrice) * 100);
    setTimeout(() => {
      setviewROI(true);
    }, 3000);
  };
  if (startDate !== null && endDate !== null) {
    var roiData = [
      {
        img: imgUrl,
        coin: coin,
        start_date: getDateFormat(startDate),
        end_date: getDateFormat(endDate),
        start_date_price: startDatePrice,
        end_date_price: endDatePrice,
        roi: ROI,
      },
    ];
  } else {
    roiData = [];
  }
  const data = roiData.map((item) => {
    return (
      <>
        {viewROI === true ? (
          <div
            className={
              mode === "dark"
                ? "darkindividualStatisticsROI"
                : "individualStatisticsROI"
            }
            style={{ fontSize: "2vh" }}
          >
            <img src={item.img} alt="Coin Icon" />
            <h2 style={{ textTransform: "capitalize" }}>{item.coin}</h2>
            <div className="socialMedia">
              <span>
                <b>Start Date:</b><p>&nbsp;</p>{item.start_date}
              </span>
              <span>
                <b>End Date:</b><p>&nbsp;</p> {item.end_date}
              </span>
            </div>
            <div>
              <h3>Calculated ROI</h3>
              <b>Price on {item.start_date}:</b>
              <p style={{ textTransform: "uppercase" }}>
                {currency}{" "}
                {
                  item.start_date_price>1
                  ?
                  <CountUp
                  end={roundOffTwoDecimal(item.start_date_price)}
                  decimals={2}
                  duration={1}
                />
                :
                  <CountUp
                    end={item.start_date_price}
                    decimals={10}
                    duration={1}
                  />
                }
              </p>
              <b>Price on {item.end_date}</b>
              <p style={{ textTransform: "uppercase" }}>
                {currency}{" "}
                {
                  item.end_date_price>1?
                  <CountUp
                  end={roundOffTwoDecimal(item.end_date_price)}
                  decimals={2}
                  duration={1}
                />
                  :
                  <CountUp
                    end={item.end_date_price}
                    decimals={10}
                    duration={1}
                  />
                }
              </p>
              <b>ROI</b>
              <p style={{ textTransform: "uppercase" }}>
                {" "}
                {item.start_date_price > item.end_date_price ? (
                  <div style={{ color: "red" }}>
                    -
                    <CountUp
                      end={roundOffTwoDecimal(item.roi)}
                      duration={2}
                      decimals={2}
                    />
                    %
                  </div>
                ) : (
                  <div style={{ color: "green" }}>
                    +
                    <CountUp
                      end={roundOffTwoDecimal(item.roi)}
                      duration={2}
                      decimals={2}
                    />
                    %
                  </div>
                )}
              </p>
            </div>
          </div>
        ) : (
          <div
            className={
              mode === "dark"
                ? "darkindividualStatisticsROI"
                : "individualStatisticsROI"
            }
            style={{ fontSize: "2vh" }}
          >
            <h2> Click on Submit to view ROI</h2>
          </div>
        )}
      </>
    );
  });
  const postData = (e) => {
    e.preventDefault();
    setcoin(e.target.value);
    if (
      startDateRef.current.props.selected &&
      endDateRef.current.props.selected
    ) {
      axios
        .get(
          `https://api.coingecko.com/api/v3/coins/${
            e.target.value
          }/history?date=${getDateFormat(startDateRef.current.props.selected)}`
        )
        .then((response) => {
          setstartDatePrice(response.data.market_data.current_price[currency]);
          setimgUrl(response.data.image.small);
          var start_date = response.data.market_data.current_price[currency];
          axios
            .get(
              `https://api.coingecko.com/api/v3/coins/${
                e.target.value
              }/history?date=${getDateFormat(
                endDateRef.current.props.selected
              )}`
            )
            .then((response) => {
              setendDatePrice(
                response.data.market_data.current_price[currency]
              );
              var end_date = response.data.market_data.current_price[currency];
              var temp = end_date - start_date;
              setimgUrl(response.data.image.small);
              setROI((temp / start_date) * 100);
            });
        });
    }

    // calculateROI(e);
    axios
      .get(
        `https://api.coingecko.com/api/v3/coins/${e.target.value}/history?date=15-06-2021`
      )
      .then((response) => {
        setimgUrl(response.data.image.small);
      })
      .catch((error) => {});
  };

  return (
    <>
      {loader === "false" ? (
        ""
      ) : (
        <div className={mode === "dark" ? "darkroi" : "roi"}>
          <div className="roiForm">
            <form onSubmit={(e) => calculateROI(e)}>
              <select onChange={postData} ref={coinRef}>
                <option value="" selected>
                  Select
                </option>
                {coinData.map((item, index) => {
                  return (
                    <option key={index} value={item.id}>
                      {item.name}{" "}
                    </option>
                  );
                })}
              </select>

              <select onChange={postDataCurrency}>
                {allCurrency.map((item, index) => {
                  return (
                    <>
                      {currency === item ? (
                        <option
                          key={index}
                          style={{ textTransform: "uppercase" }}
                          value={item}
                          selected
                        >
                          {item}
                        </option>
                      ) : (
                        <option
                          key={index}
                          style={{ textTransform: "uppercase" }}
                          value={item}
                        >
                          {item}
                        </option>
                      )}
                    </>
                  );
                })}
              </select>

              <DatePicker
                className="datepicker"
                selected={startDate}
                onChange={(date) =>
                  date <= startDateValues(date) ? "" : endDate
                }
                placeholderText="Select from date"
                dateFormat="dd-MM-yyyy"
                style={{ width: "100%" }}
                ref={startDateRef}
              />

              <DatePicker
                className="datepicker"
                selected={endDate}
                onChange={(date) =>
                  date >= startDate ? (
                    endDateValues(date)
                  ) : (
                    <span>End Date should be greater than start date</span>
                  )
                }
                placeholderText="Select to date"
                dateFormat="dd-MM-yyyy"
                style={{ width: "100%" }}
                ref={endDateRef}
              />
              {viewROI === true ? (
                ""
              ) : (
                <input
                  type="submit"
                  value="Submit"
                  style={{ marginBottom: "-20px" }}
                />
              )}
            </form>
          </div>
          {data}
        </div>
      )}
    </>
  );
};
export default ROI;
